__webpack_require__.p = "https://cmpuat.vpbank.com.vn/doanh-nghiep/";